document.addEventListener('DOMContentLoaded', function() {
  let isRemoving = false;
  const CART_PAGE_IDENTIFIER = 'cartForm'; // Update with your cart page container ID

  async function removeFreeProducts() {
    if (isRemoving) return;
    isRemoving = true;
    
    try {
      await new Promise(resolve => setTimeout(resolve, 300));
      
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw new Error('Cart fetch failed');
      
      const cart = await cartResponse.json();
      const freeItems = cart.items.filter(item => item.price === 0);
      if (freeItems.length === 0) return;

      const updates = {};
      freeItems.forEach(item => {
        updates[item.key] = 0;
      });

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({updates})
      });
      
      if (!updateResponse.ok) throw new Error('Item removal failed');

      // Determine if we're on cart page
      const isCartPage = document.getElementById(CART_PAGE_IDENTIFIER) !== null;
      
      if (isCartPage) {
        // Update cart page contents
        await refreshCartPage();
      } else {
        // Refresh cart drawer
        await refreshCartDrawer();
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      console.log('Free items removed successfully');

    } catch (error) {
      console.error('Free item removal error:', error);
    } finally {
      isRemoving = false;
    }
  }

  async function refreshCartDrawer() {
    try {
      const response = await fetch('/cart?view=ajax');
      if (!response.ok) return;
      
      const text = await response.text();
      const newContent = new DOMParser().parseFromString(text, 'text/html');
      const drawer = document.querySelector('#cart-drawer');
      
      if (drawer && newContent.querySelector('#cart-drawer')) {
        drawer.innerHTML = newContent.querySelector('#cart-drawer').innerHTML;
      }
    } catch (error) {
      console.error('Cart drawer refresh error:', error);
    }
  }

  async function refreshCartPage() {
    try {
      const response = await fetch('/cart');
      if (!response.ok) return;
      
      const text = await response.text();
      const newContent = new DOMParser().parseFromString(text, 'text/html');
      const cartContainer = document.getElementById(CART_PAGE_IDENTIFIER);
      const newContainer = newContent.getElementById(CART_PAGE_IDENTIFIER);
      
      if (cartContainer && newContainer) {
        cartContainer.innerHTML = newContainer.innerHTML;
      }
    } catch (error) {
      console.error('Cart page refresh error:', error);
    }
  }

  // Setup cart drawer observer
  const cartDrawer = document.querySelector('#cart-drawer');
  if (cartDrawer) {
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && cartDrawer.classList.contains('is-open')) {
          removeFreeProducts();
        }
      });
    }).observe(cartDrawer, {attributes: true});
  }

  // Initial execution
  removeFreeProducts();
  
  // Event listeners
  document.addEventListener('cart:updated', removeFreeProducts);
  document.addEventListener('cart:requestUpdate', removeFreeProducts);
});